module.exports = __webpack_public_path__ + "img/ejpt_badge_white.a796b46c.png";